<template lang="pug">
  .wrap
    TransitionHero(text="Mi Transición")
    .transitionunder
      h4.undertitle {{article.innertitle}}
      Sharer(:baseurl="config.baseurl", :slug="$route.path", :title="article.title || config.title", :description="article.downtitle || config.description", :img="article.shareimg || config.img", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")
    .transitionarticles
      router-link.transarticle(:to="{name: 'article', params: { section: 'mi-transicion', slug: article.slug } }" v-for="(article, index) in articles" :key="index" v-if="!article.hidden && !article.wom")
        figure
          img(:src="article.imgsmall")
          figcaption
            .titlewrap
              TransitionLogo(:text="article.title", size="3.6rem")

    .transitionspecial
      router-link.transarticle.wom-article(:to="{name: 'article', params: { section: 'mi-transicion', slug: article.slug } }" v-for="(article, index) in articles" :key="index" v-if="article.wom")
        //- .wom-header
        //-   span Presentado por
        //-   Logo(:brand="config.sponsor")
        figure
          img(:src="article.imgsmall")
          figcaption
            .titlewrap
              TransitionLogo(:text="article.title", size="3.6rem")



</template>

<script>
import { mapState } from 'vuex'
import Sharer from '@/components/Sharer'
import TransitionHero from '@/components/transition/TransitionHero'
import TransitionLogo from '@/components/transition/TransitionLogo'
import Logo from '@/components/Logo'

export default {
  components: {
    TransitionHero,
    TransitionLogo,
    Sharer,
    Logo
  },
  computed: {
    article(){
      const article = this.$store.getters.getSection(this.$route.path)
      if(typeof article === 'undefined'){
        this.$router.push({name: 'home'})
      }
      return article
    },
    ...mapState([
      'articles',
      'config'
    ]),
  }
}
</script>
<style lang="scss" scoped>
  .transitionarticles{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    position: relative;
    @media(max-width: 800px){
      grid-template-columns: auto;
    }
  }
  .transarticle{
    min-height: 40vh;
    display: block;
    position: relative;
    img{
      object-fit: cover;
      min-height: 40vh;
      display: block;
      filter: grayscale(100%);
      transition: all .3s;
      width: 100%;
    }
    figure{
      padding: 0;
      margin: 0;
    }
    figcaption{
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .titlewrap{
      background-color: black;
      display: block;
      width: 100%;
      // height: 12vh;
      margin-top: -18%;
      opacity: 0;
      transition: all .3s;
    }
    &:hover{
      img{
        filter: grayscale(0);
      }
      .titlewrap{
        opacity: 1;
      }
      figcaption{
        // background-color: rgba(black, 0.3);
        // transition: all .3s;
        // transition-delay: 0.3s;
      }
    }
  }
  .undertitle{
    @include fluid-type(360px,
  1440px,
  18px,
  26px);
    line-height: 160%;
    // font-family: 'Open Sans', sans-serif;
    text-align: center;
    font-weight: 400;
  }
  .transitionunder{
    max-width: $maxwidth;
    margin-left: auto;
    margin-right: auto;
    h4{
      padding: 2rem 0;
    }
    padding: 2rem 0;
  }
  .transitionspecial{
    margin-top: 4rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    position: relative;
    background: linear-gradient(89deg,#360b3d 0,#641672 75%);
    @media(max-width: 800px){
      grid-template-columns: auto;
    }
    .wom-header{
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Open Sans', sans-serif;
      color: white;
      font-size: 12px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    .wom-article{
      grid-column: 2 / 2;
      @media(max-width: 800px){
        grid-column: auto;
      }
    }
  }

</style>
